module.exports = __webpack_public_path__ + "img/soy-organizacion_banner_2.53952a08.webp";